module.exports = __webpack_public_path__ + "img/session-organic-form.e4bb1bef.svg";